import * as yup from 'yup'
import { useEffect } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { FormArea, FeildWraper, FeildError, FormLabel, SelectSearch } from '../../../../component/form/form-layout'

const AddCategoryForm = ({ onClose = () => { }, onError = () => { }, onSuccess = () => {}, onSubmit = () => { }, currentData, Style }) => {
    const apiCall = useApiCall();
    useEffect(() => {
        console.log("currentData", currentData)
        if (!currentData?.id) return;

        // formik.setValues({
        //     name: currentData?.name || "",
        //     status: currentData?.status,
        // });
        formik.setFieldValue("label", currentData?.category_label)
    }, [currentData]);

    const validationSchema = yup.object().shape({
        label: yup.string().required('This Field is required'),
    });

    const formik = useFormik({
        initialValues: {
            label: "",
            status: 1
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            let extraData = {}
            if (currentData?.id) {
                extraData = {
                    "id": currentData?.id,
                    "is_active": values.status
                }
            }
            const apiData = JSON.stringify({
                ...extraData,
                "category_label": values?.label,
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `office-asset/categories/update` : `office-asset/categories/add`, data: apiData });
                onSubmit();
                onSuccess(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>

                        <FeildWraper width='100%'>
                            <FormLabel required>Category Label</FormLabel>
                            <input
                                type={'text'}
                                name={'label'}
                                onChange={formik.handleChange}
                                value={formik.values.label}
                                placeholder='Category Label'
                            />
                            {formik.touched.label && formik.errors.label && (
                                <FeildError>{formik.errors.label}</FeildError>
                            )}
                        </FeildWraper>

                        {currentData?.id ?
                            <FeildWraper width='100%'>
                                <FormLabel required>Status</FormLabel>

                                <SelectSearch
                                    name="status"
                                    placeholder="- Select Status -"
                                    onChange={(val) => {formik.setFieldValue("status", val);}}
                                    value={formik.values.status}
                                    options={[
                                        {label: "Active", value: 1},
                                        {label: "In Active", value: 0},
                                    ]}
                                />
                                {formik.touched.status && formik.errors.status && (
                                    <FeildError>{formik.errors.status}</FeildError>
                                )}
                            </FeildWraper>
                            :
                            null
                        }
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
                    <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                </div>
            </form>
        </>
    )
}

export default AddCategoryForm
